<template>
  <div data-test="keywordChange">
    <div id="KeywordChange">
      <div class="columns">
        <div class="column is-4 has-text-centered">
          <h6>{{ $t('seo_service.sub_headings.google') }}</h6>
          <div
            class="card rank-card"
            data-test="google"
          >
            <div class="columns">
              <div
                v-for="entity in entities('google')"
                :key="entity.indicator"
                class="column is-6"
              >
                <rank-display :indicator="entity.indicator">
                  {{ entity.changeType }}
                </rank-display>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-4 has-text-centered">
          <h6>{{ $t('seo_service.sub_headings.mobile') }}</h6>
          <div
            class="card rank-card"
            data-test="google_mobile"
          >
            <div class="columns">
              <div
                v-for="entity in entities('google_mobile')"
                :key="entity.indicator"
                class="column is-6"
              >
                <rank-display :indicator="entity.indicator">
                  {{ entity.changeType }}
                </rank-display>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-4 has-text-centered">
          <h6>{{ $t('seo_service.sub_headings.maps') }}</h6>
          <div
            class="card rank-card"
            data-test="google_maps"
          >
            <div class="columns">
              <div
                v-for="entity in entities('google_maps')"
                :key="entity.indicator"
                class="column is-6"
              >
                <rank-display :indicator="entity.indicator">
                  {{ entity.changeType }}
                </rank-display>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RankDisplay from '@/components/Shared/RankDisplay'

export default {
  name: 'BaseRankChangeByGoogleEngine',
  components: {
    RankDisplay
  },

  props: {
    data: {
      type: Object,
      default: () => ({
        google_maps: {},
        google_mobile: {},
        google: {}
      })
    }
  },

  computed: {
    entities () {
      return (searchEngine) => {
        const engine = this.data[searchEngine]
        return [
          { changeType: engine.up, indicator: 'up' },
          { changeType: engine.down, indicator: 'down' },
          { changeType: engine.no_change, indicator: 'noChange' },
          { changeType: engine.new, indicator: 'new' }
        ]
      }
    }
  }
}
</script>
<style scoped>
  .ranking-text {
    display: inline-block;
  }
  .card-body {
    padding: 5px 5px 10px 5px;
  }
  .rank-card {
    padding: 10px;
  }
  .border-left {
    border-left: 1px solid #eeeeee;
  }
</style>
